// Package Imports
import { z } from 'zod'

// Core Imports
import { adminListSearchSchema } from '@/core/lib/table-search-schema'

const teamLogoValidationErrors = {
  file: {
    required: 'Logo görseli seçilmesi zorunludur',
  },
}

const { file } = teamLogoValidationErrors

export const teamLogoSearchSchema = adminListSearchSchema

// Create + replace both upload an image via the presigned flow.
export const teamLogoFileSchema = z.object({
  file: z.custom<File>().refine((f) => f instanceof File, {
    message: file.required,
  }),
})
